import { makeStyles } from '@material-ui/core';

export const useSidebarGroupStyles = makeStyles((theme) => ({
  container: {
    width: '290px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
}));
